import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import styles from "./ExternalProductList.module.css";
import CampaignService from "../../../service/CampaignService";

export default function ExternalProductList() {
  const location = useLocation();
  const { customerInfo, customerNo } = location.state || {}; // state가 undefined일 경우를 대비한 기본값 설정

  const handleMoveToProductDetail = async (e, product) => {
    e.preventDefault();

    try {
      const productName = product.상품명 || "";

      const result = await CampaignService.updateProductCode(customerNo, productName);

      window.location.href = product?.상품주소 || "";
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    console.log("customerInfo", customerInfo, customerNo);
  }, [customerInfo]);

  return (
    <div className="flex flex-col  min-h-screen md:max-w-[400px] bg-white mx-auto">
      <div className="flex flex-col items-center w-full mb-0   pb-[25px] mt-[100px] gap-3">
        {/* <img src="/assets/img/logo1.png" className="w-[150px] h-[47px] object-cover  " /> */}
        <img src={customerInfo?.로고경로 || ""} className="max-w-[150px]  h-[47px] object-cover mb-2" />
        {/* <p className="flex-grow-0 flex-shrink-0 text-lg font-bold text-left text-[#6a6a6a]">
        {customerInfo?.매체 || ""}
      </p> */}
      </div>

      <div className="w-full px-2 ">
        {customerInfo?.외부상품기획전리스트?.map((product, index) => {
          return product.대표이미지 ? (
            <div key={index} className="flex gap-5  px-2 border border-solid py-3 items-center object-cover mt-1 shadow-xl ">
              <div className="w-[120px] h-[120px] min-w-[120px] ">
                <img src={product.대표이미지} className="w-full h-full object-cover" alt="" />
              </div>
              <div className="flex flex-col gap-1 pr-3 justify-start w-full  text-[0.875rem]  ">
                <div className={`${styles.productName} `}>{product.상품명 || ""}</div>
                <div>최저가 : {new Intl.NumberFormat("ko-KR").format(product.최저가 || 0)}</div>
                <div className="flex justify-end">
                  <button
                    className="bg-blue-500 text-white text-[0.875rem] px-3 py-2 w-[100px] rounded-[4px] cursor-pointer "
                    onClick={(e) => handleMoveToProductDetail(e, product)}
                  >
                    예약하기
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div key={index} className="flex gap-5  px-2 border border-solid py-3 items-center object-cover mt-1 shadow-xl ">
              <div className="flex flex-col gap-1 pr-3 justify-start w-full  text-[0.875rem]  ">
                <div className={`${styles.productName} `}>{product.상품명 || ""}</div>
                <div>최저가 : {new Intl.NumberFormat("ko-KR").format(product.최저가 || 0)}</div>
                <div className="flex justify-end">
                  <button
                    className="bg-blue-500 text-white text-[0.875rem] px-3 py-2 w-[100px] rounded-[4px] cursor-pointer "
                    onClick={(e) => handleMoveToProductDetail(e, product)}
                  >
                    예약하기
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
